import { render } from "./SIBreadcrumb.vue?vue&type=template&id=34c9e89d&scoped=true"
import script from "./SIBreadcrumb.vue?vue&type=script&lang=js"
export * from "./SIBreadcrumb.vue?vue&type=script&lang=js"

import "./SIBreadcrumb.vue?vue&type=style&index=0&id=34c9e89d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34c9e89d"

export default script